import * as routerActions from "../actions/router.js"
import {LOGIN_PREVENT_OLD_VERSION} from '../actions/auth'
import Immutable from 'seamless-immutable'
import objectPath from 'object-path'

const childInitialState = Immutable({
	type: null,
	index: null,
	stack: [],
	current: {},
	timestamp: +Date.now(),
	subRouters: {}
})

// Top level State
const stack = [{name: 'Login', meta: { bottomSafeColour: "#03a9f4" }}]
const initialState = childInitialState.merge({
	stack: stack,
	current: stack[stack.length-1]
})

/**
 * Default reducer to support sub routers
 * by defining meta.for you can construct a new sub router to operate on
 * @param state
 * @param action
 * @return {*}
 */
export default function(state = initialState, action){

	// Handle model before core stack
	if(state.subRouters.modal && state.subRouters.modal.stack.length > 0 && action.type.startsWith('ROUTER_')){
		objectPath.set(action, 'meta.for', 'modal')
	}

	switch(action.type){
		case routerActions.ROUTER_REMOVE_CHILD: // Handle removing sub route stacks
			return state.setIn(['subRouters'].concat(action.name), undefined)

		case LOGIN_PREVENT_OLD_VERSION:
			return initialState
	}



	// Handle either the core route stack, or the sub route stack
	if(objectPath.has(action, 'meta.for')){
		const name = Array.isArray(action.meta.for) ? action.meta.for : [action.meta.for]

		return state.updateIn(["subRouters"].concat(name), (childState) => _router(childState, action))
	}else{
		return _router(state, action)
	}
}

/**
 * Routing function
 * @param state
 * @param action
 * @return {*}
 * @private
 */
export function _router(state = childInitialState, action){
	let currentRoute = {name: action.name}

	if(action.meta){
		currentRoute.meta = action.meta
	}

	let stack

	switch(action.type){
		case routerActions.ROUTER_PUSH:
			stack = state.stack.asMutable({deep: true})
			stack.push(currentRoute)
			return state.merge({type: action.type, index: action.index, stack: stack, timestamp: +Date.now(), current: currentRoute})

		case routerActions.ROUTER_REPLACE_AT_INDEX:
			stack = state.stack.asMutable({deep: true})
			stack[action.index] = currentRoute
			return state.merge({type: action.type, index: action.index, stack: stack, timestamp: +Date.now(), current: currentRoute})

		case routerActions.ROUTER_POP_TO_TOP:
			stack = state.stack.asMutable({deep: true})
			stack = [stack[0]]

			return state.merge({type: action.type, index: null, stack: stack, timestamp: +Date.now(), current: stack[0]})
		case routerActions.ROUTER_REPLACE:
			stack = state.stack.asMutable({deep: true})
			stack.pop()
			stack.push(currentRoute)

			return state.merge({type: action.type, index: null, stack: stack, timestamp: +Date.now(), current: currentRoute})
		case routerActions.ROUTER_POP:
			stack = state.stack.asMutable({deep: true})
			if(stack.length > 1 || objectPath.has(action, 'meta.for')){
				stack.pop()
			}

			return state.merge({type: action.type, index: null, stack: stack, timestamp: +Date.now(), current: stack[stack.length-1]})

		case routerActions.ROUTER_POP_TO_ROUTE_AND_PUSH:
			stack = state.stack.slice(0, state.stack.findIndex((route) => route.name == action.to) + 1)

			if(action.to !== action.name){
				stack = stack.concat([currentRoute])
			}

			return state.merge({type: action.type, index: null, stack: stack, timestamp: +Date.now(), current: currentRoute})

		case routerActions.ROUTER_MERGE_META:
			stack = state.stack.asMutable()
			let route = stack.pop()
			stack.push(route.set('meta', route.meta ? route.meta.merge(action.meta) : Immutable(action.meta)))

			return state.merge({stack: stack, current: route})
	}

	return state
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/reducers/router.js